import React, { useMemo } from "react";

import { Nullable } from "src/shared/utils/typescript";
import { GetDiscoveryProfilesQuery } from "src/views/hacker-directory/graphql/getDiscoveryProfiles.generated";
import { DiscoveryProfile } from "src/views/hacker-directory/shared/types";
import {
  getTeammateRelationship,
  mapDiscoveryProfile,
} from "src/views/hacker-directory/shared/utils";

import ErrorProfileCell from "../ErrorProfileCell";
import LiveProfileCell from "../LiveProfileCell";

export interface ProfileCellProps {
  profile?: GetDiscoveryProfilesQuery["profiles"][number];
  authenticatedClaimId?: Nullable<number>;
  authenticatedTeammateClaimIds?: Nullable<readonly string[]>;
  onClick?: (
    profile: DiscoveryProfile,
    event: React.MouseEvent<HTMLElement>
  ) => void;
}

const ProfileCell: React.FC<ProfileCellProps> = ({
  profile,
  authenticatedClaimId = null,
  authenticatedTeammateClaimIds = null,
  onClick,
}) => {
  const profileData = useMemo(
    () => (profile ? mapDiscoveryProfile(profile.id, profile.fields) : null),
    [profile]
  );
  if (!profileData) return <ErrorProfileCell />;
  const { name, interests, teammatesNeeded, profilePhoto } = profileData;
  const relationship = getTeammateRelationship({
    authenticatedClaimId,
    authenticatedTeammateClaimIds,
    targetClaimId: profileData.id,
    targetTeammateClaimIds: profileData.teammatesClaimIds,
  });

  return (
    <div style={{ position: "relative" }}>
      <LiveProfileCell
        profile={{ name, interests, teammatesNeeded, profilePhoto }}
        relationship={relationship}
        onClick={(event) => onClick?.(profileData, event)}
      />
    </div>
  );
};

export default React.memo(ProfileCell);
